<template>
  <v-container class="donations-container standard-content-container">
    <v-row no-gutters>
      <v-col cols="12" md="5">
        <v-row no-gutters class="title-section">
          <v-col
            cols="12"
            sm="2"
            class="link-container"
            :class="{
              'small-container':
                this.$vuetify.breakpoint.width <=
                this.$vuetify.breakpoint.thresholds.xs,
            }"
          >
            <router-link
              :to="
                donationsView === 'RemainderOfEstateMoneyDonation'
                  ? '/specific-bequests-remainder-of-estate'
                  : '/specific-donations'
              "
              class="back-arrow"
              ><v-icon large color="mid-grey" class="mt-1">{{
                icons.mdiArrowLeft
              }}</v-icon></router-link
            >
          </v-col>
          <v-col cols="12" sm="10" class="standard-title-container">
            <h1>
              Specific bequests -
              <span class="donation-type text-highlight">money</span>
            </h1>
          </v-col>
        </v-row>
      </v-col>

      <!-- <v-col cols="12" sm="1">
        <router-link
          :to="
            donationsView === 'RemainderOfEstateMoneyDonation'
              ? '/specific-bequests-remainder-of-estate'
              : '/specific-donations'
          "
          class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col> -->
      <!-- <v-col cols="12" sm="11">
        <div class="form-blurb">
          <h1>Specific bequests - <span class="donation-type">money</span></h1>
        </div>
      </v-col> -->

      <!-- <v-col cols="12" md="6"> </v-col> -->
      <v-col cols="12" md="7">
        <div class="left-section-container">
          <v-col cols="12" class="donate-section">
            <h2>How much money would you like to bequeath?</h2>

            <v-col cols="8" class="pl-0">
              <ValidationObserver ref="observer">
                <ValidationProvider
                  id="monetary_amount"
                  v-slot="{ errors }"
                  name="monetary_amount"
                  a
                  rules="required"
                >
                  <TextField
                    v-model="currencyMonetaryAmount"
                    :prefix="monetaryAmountPrefix"
                    :label="'Monetary amount*'"
                    :pattern="'[0-9\s]*'"
                    :errors="errors"
                    :name="'monetary_amount'"
                    @keypress="isNumber($event)"
                  />
                </ValidationProvider>
              </ValidationObserver>
            </v-col>
          </v-col>

          <v-col cols="12" class="donate-section">
            <h2>Who would you like to give this money to?</h2>
            <div>
              <ChooseBeneficiary
                :with-percentages="false"
                :beneficiaries="chosenBeneficiaries"
                :limit-beneficiaries="true"
                @beneficiarySelected="beneficiarySelected"
                @beneficiaryRemoved="beneficiaryRemoved"
              />
            </div>
          </v-col>

          <v-col cols="12">
            <div class="button-container">
              <GradientButton
                v-if="displayNextButton"
                :title="'Next'"
                :small="true"
                :callout="'right'"
                @gradientButtonClicked="save"
              />
            </div>
          </v-col>
        </div>
      </v-col>
    </v-row>

    <ErrorSnackbar v-model="showError" />
  </v-container>
</template>

<script>
  import ChooseBeneficiary from './ChooseBeneficiary.vue';
  import ErrorSnackbar from '../common/ErrorSnackbar.vue';
  import { formHelperMixin } from '../../mixins/form-helper-mixin';
  import { specificDonationMixin } from '../../mixins/specific-donation-mixin';
  import {
    formatCurrency,
    parseCurrency,
    isNumberCheck,
  } from '../../constants/js/currency-input';

  export default {
    name: 'MoneyDonation',
    components: {
      ChooseBeneficiary,
      ErrorSnackbar,
    },
    mixins: [formHelperMixin, specificDonationMixin],
    props: {
      specificDonation: Object,
    },
    data() {
      return {
        chosenBeneficiaries: [],
        monetaryAmount: null,
      };
    },
    computed: {
      donationsView() {
        return this.$route.name;
      },
      assetDonationOrigin() {
        return this.donationsView === 'RemainderOfEstateMoneyDonation'
          ? 'RemainderOfEstateBequest'
          : 'Bequest';
      },
      displayNextButton() {
        return this.monetaryAmount && this.chosenBeneficiaries.length;
      },
      isEditDonation() {
        return this.specificDonation;
      },
      currencyMonetaryAmount: {
        get: function () {
          return formatCurrency(this.monetaryAmount);
        },
        set: function (newValue) {
          this.monetaryAmount = parseCurrency(newValue);
        },
      },
      isGBWill() {
        return this.$store.getters.willCountry == 'GB';
      },
      monetaryAmountPrefix() {
        return this.isGBWill ? '£' : 'R';
      },
    },
    created() {
      if (this.isEditDonation) {
        this.assignDonationDetails();
      }
    },
    methods: {
      assignDonationDetails() {
        // using native JSON functions removes reactivity
        // so we can clone an object without mutating the original source
        const specificDonation = JSON.parse(
          JSON.stringify(this.specificDonation)
        );

        this.monetaryAmount = specificDonation.monetaryAmount;
        this.chosenBeneficiaries = specificDonation.beneficiaries.map(
          beneficiary => {
            return {
              id: beneficiary.id,
              beneficiaryType: beneficiary.beneficiaryType,
              beneficiaryId: beneficiary.beneficiaryId,
              beneficiaryDisplayName: beneficiary.beneficiaryDisplayName,
            };
          }
        );
      },
      beneficiarySelected(beneficiary) {
        this.chosenBeneficiaries.push(beneficiary);
      },
      beneficiaryRemoved(index) {
        this.chosenBeneficiaries.splice(index, 1);
      },
      save() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            if (this.isEditDonation) {
              this.updateSpecificDonation(this.specificDonationInputDetails());
            } else {
              this.createSpecificDonation(this.specificDonationInputDetails());
            }
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
        window.scrollTo(0, 0);
      },
      specificDonationInputDetails() {
        const beneficiaries = this.chosenBeneficiaries.map(b => {
          return {
            id: b.id,
            beneficiaryId: b.beneficiaryId,
            beneficiaryType: b.beneficiaryType,
          };
        });
        return {
          testatorId: this.testatorId,
          monetaryAmount: parseInt(this.monetaryAmount, 10),
          beneficiariesAttributes: beneficiaries,
          donationOrigin: this.assetDonationOrigin,
          donationType: 'MONEY',
        };
      },
      isNumber(event) {
        isNumberCheck(event);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .donations-container {
    padding-top: 40px;
  }
  h2 {
    line-height: 28px;
  }

  .donation-type {
    padding: 0 7px 4px 7px;
    border-radius: 7px;
    line-height: 1;
    display: inline-block;
  }

  .donation-type-money-img {
    max-width: 280px;
  }
  .donate-section {
    padding-left: 0;
  }
</style>
